export const environment = {
  production: false,
  newRelicEnabled: false,
  cognito: {
    ClientId: '64eovfmsv71grb1ha6f35unbbt',
    UserPoolId: 'us-east-1_SDvlCvMJz',
    region: 'us-east-1',
  },
  api: 'https://api-stage.autoarremate.app/api/1.0',
  webSocket: 'wss://api-stage.autoarremate.app/api/1.0/live/websocket',
  url: 'https://stage.autoarremate.app',
  urlBlog: 'https://autoarremate.com.br/',
  superBidUrl: 'https://accounts.stage.superbid.net',
  superBidRefreshTokenUrl: 'https://stgapi.s4bdigital.net/account/oauth/token',
  superBidClientId: '639cd6f24ed0b1607e7e9943-autoarremate',
  superBidStore: 'https://stgwww.superbid.net/loja-oficial/auto-arremate-1841',
  superBidAuthorizationUrl: 'https://myaccount.stage.superbid.com',
  turnstileSiteKey: '0x4AAAAAACMy1ZFSpTF3gzms',
  numberPlateProviderWarning: false,

  passwordRules: {
    minlength: 8,
    minLowercaseCharacterRule: 0,
    minUppercaseCharacterRule: 1,
    minDigitCharacterRule: 1,
    minSpecialCharacterRule: 1
  },

  iugu_id: '{{IUGU ID}}',

  checkPlanGuard: false,
  mobileCallbackAllowlist: ['myapp://autoarremate_callback'],
  imageApiEnabled: true,
  imageApi: 'https://api-stage-image.autoarremate.app/api/v1/autoarremate',
  autoArremateOemDealerId: '5d652c47d11648e0aa78a7bc',
  blindadoEquipmentId: '5d6d3f16e845c338745880e5'
};
